<template>
  <Form ref="form" :model="cur" :rules="rule" :label-width="80" label-position="right">
    <FormItem
      label="标题"
      prop="alias"
      style="display: inline-block; width: 280px; margin-right: 15px;margin-bottom: 10px;"
    >
      <Input v-model="cur.alias" :maxlength="20"/>
    </FormItem>
    <FormItem
      label="记录时间"
      prop="record_time"
      style="display: inline-block; width: 280px; margin-right: 15px;margin-bottom: 10px;"
    >
      <DatePicker
        v-model="cur.record_time"
        :transfer="true"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        placeholder="请选择记录时间"
        style="width: 100%"
      ></DatePicker>
    </FormItem>
    <FormItem
      label="就诊记录"
      prop="medical_record_id"
      style="display: inline-block; width: 280px;margin-bottom: 10px;"
    >
      <Select v-model="cur.medical_record_id" clearable>
        <Option v-for="m in medicalList" :key="m.id" :value="m.id">
          {{m.start_time.slice(0, 10)}}
          {{m.type}}
          {{m.way}}
        </Option>
      </Select>
    </FormItem>
  </Form>
</template>
<script>
import { formatDate } from '../../../utils/date'
import { mapGetters } from 'vuex'
export default {
  props: {
    record_time: {
      type: String,
      default: '',
    },
    medical_record_id: {
      type: String | Number,
      default: '',
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cur: {
        alias: '',
        record_time: null,
        medical_record_id: '',
      },
      rule: {
        alias: [
          {
            required: true,
            message: '请填写标题',
            trigger: 'blur',
          },
          {
            required: true,
            message: '请填写标题',
            trigger: 'change',
          },
        ],
        record_time: [
          {
            required: true,
            type: 'date',
            message: '请选择记录时间',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['medicalList']),
  },
  created() {
    this.cur.record_time = this.record_time
      ? new Date(this.record_time)
      : new Date()
    if (this.medical_record_id) {
      if (this.medical_record_id === 'temp') {
        const curDate = formatDate(new Date())
        const curRecord = this.medicalList.find(
          (m) => formatDate(new Date(m.start_time)) === curDate
        )
        this.cur.medical_record_id = curRecord ? curRecord.id : ''
      } else {
        this.cur.medical_record_id = this.medical_record_id
      }
    } else {
      this.cur.medical_record_id = ''
    }
    this.cur.alias = this.title
  },
  watch: {
    record_time(newVal) {
      this.cur.record_time = newVal ? new Date(newVal) : new Date()
    },
    medical_record_id(newVal) {
      if (newVal) {
        if (newVal === 'temp') {
          const curDate = formatDate(new Date())
          const curRecord = this.medicalList.find(
            (m) => formatDate(new Date(m.start_time)) === curDate
          )
          this.cur.medical_record_id = curRecord ? curRecord.id : ''
        } else {
          this.cur.medical_record_id = newVal
        }
      } else {
        this.cur.medical_record_id = ''
      }
    },
    title(newVal) {
      this.cur.alias = newVal;
    }
  },
  methods: {
    validate(params, type) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { record_time, medical_record_id, alias } = this.cur
          let p = Object.assign({}, params, {
            record_time: formatDate(record_time, 0, 'yyyy-MM-dd hh:mm:ss'),
            medical_record_id, alias
          })
          this.$emit('valid', p, type)
        }
      })
    },
  },
}
</script>
<style lang="less"></style>
